import { PageResponse } from '@models/page-response';
import { MainComponent } from '../main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConstant } from '@constants/app.constant';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { Component, ViewChild } from '@angular/core';
import { switchMap, debounceTime, distinctUntilChanged, catchError } from 'rxjs/operators';
import { Group, GroupSearchingCriteria } from '@app/models/group';
import { GroupService } from '@app/services/group.service';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { BaseSearchingCriteria } from '@app/models/customer/company';
import { OnepageTemplate, OnePageTemplateSearchingCriteria } from '@app/models/onepage-template';
import { OnepageTemplateService } from '@app/services/onepage-template.service';
import { ErrorResponse } from '@app/models/error.response';

@Component({
    templateUrl: './onepage-template-list.component.html',
    styleUrls: ['./onepage-template-list.component.scss']
})
export class OnepageTemplateListComponent {

    private searchTermStream = new Subject<string>();
    
    loading: boolean = false;

    globalCriteria: string = '';
    searchingCriteria: OnePageTemplateSearchingCriteria = new OnePageTemplateSearchingCriteria();

    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';
    selectedTemplateId: string;
    statusOptions: string[] = ['ENABLED', 'DISABLED'];

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    records: OnepageTemplate[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private emailTemplateService: OnepageTemplateService,
        private translate: TranslateService,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.globalCriteria = params['global'] || '';
                    this.page = Number(params['page']) || 1;
                    this.sortField = params['sortField'] || 'onepageTemplateCode';
                    this.sortDirection = params['sortDirection'] || 'asc';

                    if (params['searchingCriteria'] != null) {
                        this.searchingCriteria = JSON.parse(params['searchingCriteria']);
                    } else {
                        this.searchingCriteria = new OnePageTemplateSearchingCriteria();
                    }

                    return this.emailTemplateService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection);
                })
            )
            .subscribe((res: PageResponse<OnepageTemplate>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }
            });

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((term: string) => this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection));

    }

    deploy(templateId): void {
        // this.deploymentConfigSelector.open(templateId, true);
        // this.selectedTemplateId = templateId;
        // this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH, {
        //     id: `ID_${templateId}`
        // }]);
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH+'/ID_'+templateId]);
        
    }

    copy(templateId): void{
        this.loading = true;
        this.emailTemplateService.copy(templateId).subscribe(res0 => {
           
                this.translate.get(ModulePathConstant.ONEPAGE_TEMPLATE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_COPIED_SUCCESS, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });

                         if(res0['content'] && res0['content']['id']){
                            this.router.navigate(['/onepage-template', res0['content']['id']]);
                        }
                    });
        }, (error: ErrorResponse) => {
            this.loading = false;
        });

    }
    

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.sortDirection);
    }

    ngOnDestroy(): void {
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.sortDirection);
        }
    };

    search(term: string) {
        this.searchTermStream.next(term);
    }

    private doSearch(criteria: string, page: number, sortField: string, sortDirection: string) {
        this.records = [];
        this.loading = true;
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_PATH, {
            global: criteria,
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            searchingCriteria: JSON.stringify(this.searchingCriteria)
        }]);
    }

    
    onDeploymentSet(useOriginalUrl: boolean) {
        console.debug('task config finished '+useOriginalUrl)
        
        this.emailTemplateService.deploy(this.selectedTemplateId).subscribe(response=>{
            alert(response);
        });
    }




}
